export default "/images/login-bg.jpg?d82030a1b9bfa9f434d14e44a631bb77";